import { Button } from "@mui/material";
import Form from "@rjsf/core";
import validator from '@rjsf/validator-ajv8';
import axios from "axios";
import {v4 as uuidV4} from 'uuid'
import { useState,useRef, createRef, useEffect } from "react";
const axiosWithHeader=axios.create({
    headers: {
    'Access-Control-Allow-Origin' : '*',
    'Authorization':'Bearer c03dfc37-08ce-4775-ac2c-c43c6ed7efd3'
  }})
const schema = require ("./jsonSchems/suppliers.json")
const schemaUpdate=require("./jsonSchems/suppliersUpdate.json")
const uischema = {
            "type" :{
                "ui:widget": "hidden",
            }
    }
export const authViaJwt = async(token)=>{
    let url = `https://ibanity.hhinformatique.be/jwtAuth?token=${encodeURIComponent(token)}`
    console.log(url)
    let res = await axiosWithHeader.get(
        url
    )
    
    if(res.status==200){
        console.log("DATA",res.data)
        return(res.data)
    }
    else{
        throw(res.status)
    }
}
export const invoiceStatusRead=async(idSupplier,idInvoice)=>{
    let res = await axiosWithHeader.get(
        `https://ibanity.hhinformatique.be/invoice/?suppliers=${idSupplier}&invoice=${idInvoice}`
        )
        console.log(res)
        let ret = new Promise ((resolve,reject)=>{
            if (res.status===200){
                resolve(res.data)
            }
            else{
                reject(false)
            }
        })
        return(ret)
}
export const historyRead=async()=>{
    let res =  await axiosWithHeader.get("https://ibanity.hhinformatique.be/history")
    let ret = new Promise((resolve,reject)=>{
        if(res.status===200){
            resolve(res.data)
        }
        else{
            reject(false)
        }
    })
    return(ret)
}
export const deleteSupplier=async(supplierID)=>{
    let res = await axiosWithHeader.delete("https://ibanity.hhinformatique.be/supplier?id="+supplierID)
    
        let ret = new Promise((resolve,reject)=>{
            if(res.status===200){
                resolve(true)
            }
            else{
                reject(false)
            }
        })
    }

export const updateSupplier=async(supplier)=>{
    let res = await axiosWithHeader.put("https://ibanity.hhinformatique.be/supplier",supplier)
    let ret = new Promise((resolve,reject)=>{
        if(res.status===200){
            resolve(true)
        }
        else{
            reject(false)
        }
    })
}
export const suppliersRead= async ()=>{
    let res = await axiosWithHeader.get('https://ibanity.hhinformatique.be/suppliers')
    if (res.status===200){
        console.log(res.data)
        return(res.data)
        
    }
}
export const resendInvoice=async (id,supplierId)=>{
 let res = await axiosWithHeader.post("https://ibanity.hhinformatique.be/resendinvoice?id="+id+"&senderToken="+supplierId)
 if(res.status===200){
        return(true)
    }
    else{
        return(false)
    }
}
export const updateInvoice=async(id,newNum)=>{
    let res = await axiosWithHeader.put("https://ibanity.hhinformatique.be/invoice?id="+id+"&newTva="+newNum)
    if(res.status===200){
        return(true)
    }
    else{
        return(false)
    }
}
export const supplierDocuments=async(supplier,from_date,to_date)=>{
    let res = await axiosWithHeader.get("https://ibanity.hhinformatique.be/documents/?suppliers="+supplier+"&from_date="+from_date+"&to_date="+to_date)
    if(res.status===200){
        return(res.data)
    }
    else
    {
        return ([])
    }
}
export const SupplierUpdate=({callback=(()=>{}),id})=>{

    const [formData,setFormData]=useState(null)
    const formRef=createRef()
    const [submited,setSubmited]=useState(null)
    const [res,setRes]=useState(null)
    useEffect(()=>{
        //On récupere les infos du supplier et on les passe en data : 
        console.log("MYID",id)
        axiosWithHeader.get("https://ibanity.hhinformatique.be/supplier?id="+id).then(data=>{
            console.log(data.data)
            setFormData(data.data.data)
        }
        )
    },[])
    useEffect(()=>{
        if( res!==null){
            res===true?
                alert("OK")
            :
                alert("Error")
        }
    },[res])
    const validate = ()=>{
        console.log()
        try{
            if(formRef.current.validateForm() || 1===1){
                setSubmited(true)
                //OK 
                if(formData?.attributes.country==='LU'){
                    try{
                    delete(formData.attributes.enterpriseIdentification.enterpriseNumber)
                    }
                    catch{}
                        
                }
                    
                if(formData?.attributes?.representativeIdScan){
                    formData.attributes.representativeIdScan=formData.attributes.representativeIdScan.split(";")[2].replace("base64,","")
                      console.log(formData.attributes)
                if(formData.attributes.businessRegisterScan){
                    formData.attributes.businessRegisterScan=formData.attributes.businessRegisterScan.split(";")[2].replace("base64,","")
                }
                }
                try{
                    if (Array.isArray(formData.attributes.names)){
                        formData.attributes.names.forEach(name=>
                        {if(name.id){
                            delete(name.id)
                        }}
                        )
                    }
                    if (Array.isArray(formData.attributes.ibans)){
                        formData.attributes.ibans.forEach(name=>
                        {if(name.id){
                            delete(name.id)
                        }}
                        )
                    }
                }
                catch{}
                delete(formData.attributes.createdAt)
                delete(formData.attributes.onboardingStatus)
                delete(formData.attributes.companyNumber)
                delete(formData.attributes.enterpriseIdentification)
                delete(formData.attributes.country)
                delete(formData.attributes.peppolReceiver)
            
                axiosWithHeader.patch("https://ibanity.hhinformatique.be/supplier?supplier="+formData.id,JSON.stringify({data:formData}),{headers:{'Authorization':'Bearer 15efd095-ec92-4cd3-b8a9-0186fbfb367d'}}).then((data)=>{setRes(true);console.log(data.data)}).catch((e)=>{setRes(false);console.log("ERROR",e)})
                console.log(JSON.stringify({data:formData}))
                
            }
            else{
                setSubmited(false)
                alert("Impossible ")
                console.log(JSON.stringify(formData))
            }
        }
        catch(e){
            console.log("E",e)
            alert("boum")
            setSubmited(null)
        }
        
    }
    //alert(submited)
    return(
        <Form
            schema={schemaUpdate}
            uiSchema={uischema}
            ref={formRef}
            validator={validator}
            formData={formData}
            //liveValidate 
            //action={validate()}
            //onChange={()=>validate()}
            onChange={(e)=>{setFormData({...e.formData,type:'supplier'});console.log(e.formData)}}
            showErrorList={"bottom"}
            experimental_defaultFormStateBehavior={{
                emptyObjectFields: 'populateRequiredDefaults' ,
              }}
            liveValidate={submited===null?false:true}
            >
        <div><Button onClick={()=>{validate()}}>Envoyer</Button></div>
        </Form>
        
    )
}
export const SuppliersAdd =(callback=(()=>{}))=>{
    const [formData,setFormData]=useState(null)
    const formRef=createRef()
    const [submited,setSubmited]=useState(null)
    const [res,setRes]=useState(null)
    useEffect(()=>{
        if( res!==null){
            res===true?
                alert("OK")
            :
                alert("Error")
        }
    },[res])
    const validate = ()=>{
        console.log("VALIDATIN")
        try{
            if(formRef.current.validateForm()){
                setSubmited(true)
                //OK 
                formData.attributes.representativeIdScan=formData.attributes.representativeIdScan.split(";")[2].replace("base64,","")
                if(formData.attributes.businessRegisterScan){
                    formData.attributes.businessRegisterScan=formData.attributes.businessRegisterScan.split(";")[2].replace("base64,","")
                }
                
                axiosWithHeader.post("https://ibanity.hhinformatique.be/supplier",JSON.stringify({data:formData}),{headers:{'Authorization':'Bearer 15efd095-ec92-4cd3-b8a9-0186fbfb367d'}}).then((data)=>{setRes(true);console.log(data.data)}).catch((e)=>{setRes(false);console.log("ERROR",e)})
                console.log(JSON.stringify({data:formData}))
                
            }
            else{
                setSubmited(false)
               
                console.log(JSON.stringify(formData))
            }
        }
        catch{
            alert("boum")
            setSubmited(null)
        }
        
    }
    //alert(submited)
    return(
        <Form
            schema={schema}
            uiSchema={uischema}
            ref={formRef}
            validator={validator}
            formData={formData}
            //liveValidate 
            //action={validate()}
            //onChange={()=>validate()}
            onChange={(e)=>{setFormData({...e.formData,type:'supplier'});console.log(e.formData)}}
            showErrorList={"bottom"}
            experimental_defaultFormStateBehavior={{
                emptyObjectFields: 'populateRequiredDefaults' ,
              }}
            liveValidate={submited===null?false:true}
            >
        <div><Button onClick={()=>{validate()}}>Envoyer</Button></div>
        </Form>
        
    )
}